import { render, staticRenderFns } from "./AkinonOrderStatus.vue?vue&type=template&id=660c6f08"
import script from "./AkinonOrderStatus.vue?vue&type=script&lang=js"
export * from "./AkinonOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./AkinonOrderStatus.vue?vue&type=style&index=0&id=660c6f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports